import * as React from 'react';
import { CookieBannerFeaturesList } from '../elements/cookie-banner-features-list';
export var CookieBannerFeaturesListContext = React.createContext(null);
export var CookieBannerFeaturesListProvider = CookieBannerFeaturesListContext.Provider;
export var useCookieBannerFeaturesList = function () {
  return React.useContext(CookieBannerFeaturesListContext) || React.createElement(CookieBannerFeaturesList, null);
};